<template>
  <div class="Category-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar
          v-if="Category"
          :title="`P & L by Customer`"
          :start="start"
          :end="end"
        />

        <v-card-text class="pb-0">
          <div class="d-flex align-center flex-wrap">
            <v-select
              v-model="groupBy"
              :items="groupByOptions"
              item-text="text"
              item-value="value"
              dense
              outlined
              hide-details
              label="Group by"
              class="mr-4"
              style="max-width: 220px"
              @change="onChangeGroupBy"
            />

            <v-switch
              v-model="serializedItem"
              inset
              dense
              label="Show only serialized items"
              class="ma-0"
              @change="onToggleSerialized"
            />
          </div>
        </v-card-text>

        <table class="center">
          <tbody class="report-container">
            <v-card-text>
              <CategoryByProduct
                @fatchData="setIncome"
                :start="$route.query.start"
                :end="$route.query.end"
                :CustomerId="$route.query.CustomerId"
                :serializedItem="serializedItem"
                :groupBy="groupBy"  
              />
            </v-card-text>
          </tbody>
        </table>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import payeeService from "@/modules/Expense/Payee/service";
const CategoryByProduct = () =>
  import("@/modules/ReportView/GlobalReport/ProfitByCategory.vue");
// const ExpenseList = () =>
//   import("@/modules/ReportView/components/subComponents/Expense");

import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      groupBy: "category",
      groupByOptions: [
        { text: "By Category", value: "category" },
        { text: "By Department", value: "department" },
        { text: "By Brand", value: "brand" },
      ],
      start: null,
      categoryProfit: 0,
      end: null,
      panel: [0, 1],
      serializedItem: false,
      isLoading: true,
      Category: [],
      Expense: [],
      expanded: [],
      expenseExpanded: [],
      headers: [
        { text: "", value: "data-table-expand" },
        {
          text: "NAME",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "SALE",
          align: "right",
          value: "totalPrice",
          sortable: true,
        },
        {
          text: "COST",
          align: "right",
          value: "totalCost",
          sortable: true,
        },
        {
          text: "PROFIT",
          align: "right",
          value: "totalProfit",
          sortable: true,
        },
      ],
      expenseHeaders: [
        { text: "", value: "data-table-expand" },
        {
          text: "NAME",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "AMOUNT",
          align: "right",
          value: "totalExpenses",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    totalProfit() {
      return this.categoryProfit - this.totalExpense;
    },
    profitColor() {
      let color = "green";
      if (this.totalProfit > 0) {
        color = "green";
      } else {
        color = "red";
      }
      return color;
    },
    // categoryProfit() {
    //   let total = 0;
    //   this.Category.map((row) => {
    //     total += row.totalPrice - row.totalCost;
    //   });
    //   return total;
    // },
    totalExpense() {
      let total = 0;
      this.Expense.map((row) => {
        // console.log('expe row', row, row.totalExpenses)
        total += row.totalExpenses;
      });
      return total;
    },
  },
  async created() {
    if (!this.currentBusiness) this.initUser();
    this.start = this.$route.query.start;
    this.end = this.$route.query.end;
    this.serializedItem =
      this.$route.query.serializedItem === "true" ||
      this.$route.query.serializedItem === "1";
    this.groupBy = this.$route.query.groupBy || "category";
    // await this.getPayeeExpenses();
    this.isLoading = false;
  },
  components: { CategoryByProduct, ReportViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    onChangeGroupBy() {
      const q = { ...this.$route.query };
      q.groupBy = this.groupBy;
      this.$router.replace({ query: q });
    },
    onToggleSerialized() {
      // update URL query so refresh/share keeps state
      const q = { ...this.$route.query };

      if (this.serializedItem) q.serializedItem = "true";
      else delete q.serializedItem;

      this.$router.replace({ query: q });

      // reload expense (income reload happens via CategoryByProduct watcher)
      // this.isLoading = true;
      // this.getPayeeExpenses().finally(() => (this.isLoading = false));
    },
    setIncome(val) {
      this.categoryProfit = val;
    },
    color(item) {
      let value = "black";
      let profit = item.totalPrice - item.totalCost;
      if (profit < 0) {
        value = "red";
      }
      return value;
    },
    openProductReport(category) {
      // console.log("category", category);
      let routeData = this.$router.resolve({
        path: `/reportView/profitAndLose/byProduct?start=${this.start}&end=${this.end}&CategoryId=${category.id}`,
      });
      window.open(routeData.href, "_blank");

      // this.$router.push({path: '/reportView/sale/byProduct', query: { start: this.start, end: this.end }})
    },
    getPayeeExpenses() {
      return payeeService
        .getAllPayeeExpenseTotal({ start: this.start, end: this.end })
        .then((response) => {
          this.$Progress.finish();
          this.Expense = response.data;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }
  .no-print {
    display: none;
  }
  .detailBox {
    overflow: visible;
    height: 100%;
  }
  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}
.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}
.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */
</style>
